module.exports = __webpack_public_path__ + "static/media/صيّن.20fb8ae5.jpeg";